document.addEventListener('DOMContentLoaded', () => {
  // Select all elements with details-drawer-opener attribute
  const drawerOpeners = document.querySelectorAll('[details-drawer-opener]');
  
  drawerOpeners.forEach(opener => {
    opener.addEventListener('click', (evt) => {
      evt.preventDefault();
      const drawerName = opener.getAttribute('details-drawer-opener');
      const drawer = document.querySelector(`side-drawer[data-name="${drawerName}"]`);
      
      if (drawer) {
        document.body.appendChild(drawer);
        drawer.open(opener);
      }
    });
  });
});

// Custom element for tabbed details
class TabbedDetails extends HTMLElement {
  constructor() {
    super();
    this.details = Array.from(this.getElementsByTagName('details'));
    this.buttonContainer = document.createElement('div');
    this.buttonContainer.className = 'tab-buttons';
    this.insertBefore(this.buttonContainer, this.details[0]);
    
    // Create buttons and hide summaries
    this.details.forEach((detail, index) => {
      const summary = detail.querySelector('summary');
      if (summary.textContent.trim() !== '') {
      summary.style.display = 'none'; // Hide the summary instead of removing it
      
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'tab-button';
      button.textContent = summary.textContent;
      button.setAttribute('data-index', index);
      button.setAttribute('aria-controls', `tab-content-${index}`);
      button.setAttribute('role', 'tab');
      button.setAttribute('aria-selected', index === 0 ? 'true' : 'false');
      this.buttonContainer.appendChild(button);
      }
    });
    
    // Set first details element open by default
    if (this.details.length > 0) {
      //this.details[0].open = true;
      //this.buttonContainer.querySelector('button').classList.add('active');
    }
    
    // Add ARIA attributes for accessibility
    this.buttonContainer.setAttribute('role', 'tablist');
    this.details.forEach((detail, index) => {
      detail.setAttribute('role', 'tabpanel');
      detail.setAttribute('id', `tab-content-${index}`);
      detail.setAttribute('aria-labelledby', `tab-${index}`);
    });
    
    this.setupEventListeners();
  }

  setupEventListeners() {
    this.buttonContainer.addEventListener('click', (event) => {
      if (event.target.matches('.tab-button')) {
        const index = parseInt(event.target.getAttribute('data-index'));
        const clickedDetail = this.details[index];
        this.handleDetailClick(clickedDetail, event.target);
      }
    });
  }

  handleDetailClick(clickedDetail, clickedButton) {
    // Update button states
    this.buttonContainer.querySelectorAll('.tab-button').forEach(button => {
      button.classList.remove('active');
      button.setAttribute('aria-selected', 'false');
    });
    
    // Close all other details
    this.details.forEach(detail => {
      if (detail !== clickedDetail) {
        detail.open = false;
      }
    });
    
    // Open the clicked detail and activate button
    clickedDetail.open = true;
    clickedButton.classList.add('active');
    clickedButton.setAttribute('aria-selected', 'true');
  }
}

// Register the custom element
customElements.define('tabbed-details', TabbedDetails);

// Create lightbox functionality for tab images
class ImageLightbox {
  constructor() {
    this.createLightbox();
    this.setupEventListeners();
  }

  createLightbox() {
    this.lightbox = document.createElement('div');
    this.lightbox.className = 'image-lightbox';
    this.lightbox.innerHTML = `
      <div class="lightbox-content">
        <button class="lightbox-close" aria-label="Close lightbox">×</button>
        <img src="" alt="" class="lightbox-image">
      </div>
    `;
    document.body.appendChild(this.lightbox);
  }

  setupEventListeners() {
    // Add click listeners to all tab images
    document.addEventListener('click', (e) => {
      if (e.target.matches('.tab-image img')) {
        this.openLightbox(e.target);
      }
    });

    // Close lightbox on click outside or close button
    this.lightbox.addEventListener('click', (e) => {
      if (e.target.matches('.lightbox-close') || e.target.matches('.image-lightbox')) {
        this.closeLightbox();
      }
    });

    // Close on escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.lightbox.classList.contains('active')) {
        this.closeLightbox();
      }
    });
  }

  openLightbox(imageElement) {
    const lightboxImage = this.lightbox.querySelector('.lightbox-image');
    lightboxImage.src = imageElement.src;
    lightboxImage.alt = imageElement.alt;
    this.lightbox.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  closeLightbox() {
    this.lightbox.classList.remove('active');
    document.body.style.overflow = '';
  }
}

// Initialize lightbox
document.addEventListener('DOMContentLoaded', () => {
  new ImageLightbox();
});

